import { Translate } from '@chipinside/translate'
import SearchIcon from '@mui/icons-material/Search'
import { Chip, IconButton, Stack, Typography, useMediaQuery } from '@mui/material'
import Paper from '@mui/material/Paper'
import { Option } from 'lucide-react'

import { isMac } from '#/utils/device'

export const GlobalSearchShortcut = ({
  onClick,
  text,
}: {
  text: string
  onClick: VoidFunction
}) => {
  return (
    <Chip
      size="small"
      sx={{
        borderRadius: 2,
        color: '#666',
        display: { md: 'flex', xs: 'none' },
        mr: 1,
        py: 1.5,
      }}
      onClick={onClick}
      label={
        <Typography variant="overline" sx={{ fontSize: 12, fontWeight: 600 }}>
          {text}
        </Typography>
      }
    />
  )
}

const OpenSearchShortcut = () => {
  return (
    <Chip
      size="small"
      sx={{ borderRadius: 2, display: { md: 'flex', xs: 'none' }, mr: 1, opacity: 0.7, py: 1.5 }}
      label={
        <Stack
          direction="row"
          sx={{
            '& > span': {
              lineHeight: 'normal',
            },
            'alignItems': 'center',
            'gap': 0.25,
          }}
        >
          {isMac ? (
            <>
              <Option size={12} strokeWidth={2.5} />
              <Typography variant="overline" sx={{ fontSize: 12, fontWeight: 600, ml: 0.4 }}>
                {' + S'}
              </Typography>
            </>
          ) : (
            <Typography variant="overline" sx={{ fontSize: 12, fontWeight: 600 }}>
              Alt + S
            </Typography>
          )}
        </Stack>
      }
    />
  )
}

export default function GlobalSearchInput({ onClick }: { onClick: () => void }) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.only('xs'))

  if (isMobile) {
    return (
      <IconButton id="global-search" onClick={onClick}>
        <SearchIcon />
      </IconButton>
    )
  }

  return (
    <Paper
      id="global-search"
      onClick={onClick}
      elevation={0}
      sx={{
        '&:hover': {
          backgroundColor: theme => theme.palette.grey[100],
          borderColor: theme => theme.palette.primary.main,
        },
        'alignItems': 'center',
        'border': '2px solid',
        'borderColor': 'grey.300',
        'borderRadius': 3,
        'cursor': 'pointer',
        'display': 'flex',
        'height': 40,
        'ml': '20px !important',
        'userSelect': 'none',
        'width': 400,
      }}
    >
      <SearchIcon sx={{ mx: 1 }} />
      <Typography sx={{ color: 'text.secondary', flexGrow: 1, mr: 4 }}>
        {Translate({ messageKey: 'search' })}
      </Typography>
      <OpenSearchShortcut />
    </Paper>
  )
}
